import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomX = createSvgIcon(
  <path d="M18.03 2.66h3.17l-6.93 7.92 8.16 10.77h-6.38l-4.99-6.54-5.72 6.54H2.17l7.41-8.47L1.76 2.66h6.55l4.51 5.97 5.22-5.97zm-1.11 16.79h1.76L7.33 4.46H5.45l11.46 14.99z" />,
  'CustomX',
);

export default CustomX;
